import React from 'react';
import { TabChoose } from '@beisen/chaos-ui';
import Staff from '../Staff/Staff';
import * as urlHelper from '../../util/url';
import * as approvelHelper from '../../util/approvelHelper';
import transLoader from '@beisen/i18n-translation-loader';
import './AddSign.scss';

const defaultTranslation = {
    addSignResFaildTip: '获取加签信息失败'
};

class AddSign extends React.Component {
    constructor(props) {
        super(props);
        this.handleSignTypeChange = this.handleSignTypeChange.bind(this);
        this.handleSignStaffChange = this.handleSignStaffChange.bind(this);
        this.state = {
            'formDes': '',
            'signType': [],
            'activeType': '',
            'assignes': {}
        };
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            addSignResFaildTip: 'approval.addSignResFaildTip'
        }), props.translation);
    }

    componentDidMount() {
        this.props.stopLoadForField && this.props.stopLoadForField();
        const { translation } = this;
        const params = {
            method: 'GET',
            credentials: 'same-origin'

        };
        const failureCallBack = function(res) {
            this.props.actions.showTip({ message: res.Message || translation.addSignResFaildTip, type: 'error' });
            this.props.stopLoadForField && this.props.stopLoadForField();
        }.bind(this);

        const successCallBack = function(res) {
            //console.log(data,'data');
            res.activeType = res.activeType || res.signType && res.signType[0].value;
            this.setState({ ...res },() => {
                this.props.stopLoadForField && this.props.stopLoadForField();
                this.handleChangeField({ signType: res.activeType,signApprovers: res.assignes && res.assignes.value });
            });
        }.bind(this);
        window.CommonFetch(this.getFetchUrl(), params, successCallBack, failureCallBack, this.props.analysisData);
    }

    getFetchUrl() {
        return urlHelper.keepHttpsProtocolSame(`/api/v1/WF/ProcessHandle/GetAddSignDescription?app=${window.BSGlobal.application}&taskInstanceId=${this.props.workflowTaskId}`);
    }

    handleChangeField(obj) {
        const signType = { name: this.props.signType.cmp_name, value: obj.signType, required: true };
        const signApprovers = { name: this.props.signApprovers.cmp_name, value: obj.signApprovers, required: (this.state.activeType == approvelHelper.SIGNAND || this.state.activeType == approvelHelper.SIGNBEFORE) };
        this.props.onChange && this.props.onChange([signType,signApprovers]);
    }

    handleSignTypeChange(obj) {
        //console.log(obj.value);
        this.setState({ activeType: obj.value },() => {
            this.handleChangeField({ signType: obj.value, signApprovers: this.state.assignes && this.state.assignes.value });
        });
    }

    handleSignStaffChange(obj) {
        //console.log(obj);
        this.setState({ assignes: { text: obj.text, value: obj.value, avatars: obj.avatars } },() => {
            this.handleChangeField({ signType: this.state.activeType, signApprovers: obj.value });
        });
    }

    render() {
        return (<div>
                    <span className="form-des">{this.state.formDes}</span>
                    <TabChoose {...this.props.signType} wrap={window.userLang == 'en_US'} options={this.state.signType} handleChooseChange={this.handleSignTypeChange} activeValue={this.state.activeType} />
                    <Staff {...this.props.signApprovers} required={(this.state.activeType == approvelHelper.SIGNAND || this.state.activeType == approvelHelper.SIGNBEFORE)} useAddBtn={this.state.signType.length > 1}
                                            errorMessage={this.state.signStaffError}
                                            isReadOnly={false}
                                            onChange={this.handleSignStaffChange}
                                            avatars={this.state.assignes && this.state.assignes.avatars}
                                            text={this.state.assignes && this.state.assignes.text}
                                            value={this.state.assignes && this.state.assignes.value} />
        </div>);
    }
}

export default AddSign;



// WEBPACK FOOTER //
// ./src/components/Field_Components/AddSign/AddSign.js